<template>
    <div class="product-favorite" :class="{'active' : isFav}" @click="addToFavs"></div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name    : "MobileFavorite",
    props   : {
        id: Number,
    },
    methods : {
        ... mapActions([
            'ADD_FAVS_ITEM', 'DEL_FAVS_ITEM'
        ]),
        addToFavs() {
            if(this.isFav)
                this.DEL_FAVS_ITEM(this.id);
            else
                this.ADD_FAVS_ITEM({ID: this.id});
        }
    },
    computed: {
        ... mapState([
            'moduleFavorites'
        ]),
        isFav() {
            for(let fav in this.moduleFavorites.favorites)
                if(parseInt(this.moduleFavorites.favorites[fav].ID) === this.id)
                    return true;
            return false;
        },
    }
}
</script>

<style scoped>

</style>